import React from "react";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import { dateFormat } from "helpers/utils"
import Status from 'components/presentation/Status';
import Label from "components/general/Label";
import ScoresLiveCard from "components/common/ScoresLiveCard";

export function CompetitorBlock(competitor) {
    let seed = ''
    let competitorBracket;
    if (competitor.co_seed) {
        seed = '(' + competitor.co_seed + ')'
    }

    if (competitor?.itemType === 'A' || competitor?.participant?.code?.includes('TEAM')) {
        competitorBracket = <div><Competitor
            {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} /></div>
    } else {
        competitorBracket = <div><Competitor hidePicture={true} hideNoc={true} noLink={true} teamAthletes={competitor?.teamAthletes} /></div>
    }

    //Check if the game is singles or doubles    
    return (
        <div className='score-competitor-container d-flex justify-content-start text-truncate'>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name d-flex align-items-center'>
                {competitorBracket}
                <span><sup>{seed}</sup></span>
            </div>
        </div>
    )
}

export function Footer({ data }) {
    return (
        <div className='scores-today-status'>
            <Status typeToPrint={'result'} scheduleStatus={data?.status?.code} resultStatus={data?.result?.status?.code} />
        </div>
    )
}

export function Header({ data }) {
    return (
        <><div className='scores-today-header'>
            <div className='scores-today-piste-tte'>
                <div className='w-80'>
                    {data?.eventUnit?.description}
                </div>
                <div className='text-end'>
                    {dateFormat(data?.startDate, undefined, 'HH:mm')}{ }
                </div>
            </div>
        </div></>
    )
}

export function CardsLayout({ results, isMobile }) {

    const table1 = results?.filter(res => res?.location?.code === 'TT1')
    const table2 = results?.filter(res => res?.location?.code === 'TT2')
    const table3 = results?.filter(res => res?.location?.code === 'TT3')
    const table4 = results?.filter(res => res?.location?.code === 'TT4')

    return (<>
        <div className={isMobile ? "d-flex flex-column" : ""} >
            <div className={isMobile ? "" : "d-flex justify-content-around"}>
                {table1.length > 0 && <div className={isMobile ? "" : "d-flex flex-column"}>
                    <div className="card">
                        <div className="card-body">
                            <div className="fw-bold">{table1?.find(t => t)?.location?.shortDescription}</div>
                        </div>
                    </div>
                    {table1 && table1?.map((item, index) => {
                        return (<div key={index}><ScoresLiveCard data={item} key={item?.eventUnit?.code} /></div>)
                    })}
                </div>}
                {table2.length > 0 && <div className={isMobile ? "" : "d-flex flex-column"}>
                    <div className="card">
                        <div className="card-body">
                            <div className="fw-bold">{table2?.find(t => t)?.location?.shortDescription}</div>
                        </div>
                    </div>
                    {table2 && table2?.map((item, index) => {
                        return (<div key={index}><ScoresLiveCard data={item} key={item?.eventUnit?.code} /></div>)
                    })}
                </div>}
                {table3.length > 0 && <div className={isMobile ? "" : "d-flex flex-column"}>
                    <div className="card">
                        <div className="card-body">
                            <div className="fw-bold">{table3?.find(t => t)?.location?.shortDescription}</div>
                        </div>
                    </div>
                    {table3 && table3?.map((item, index) => {
                        return (<div key={index}><ScoresLiveCard data={item} key={item?.eventUnit?.code} /></div>)
                    })}
                </div>}
                {table4.length > 0 && <div className={isMobile ? "" : "d-flex flex-column"}>
                    <div className="card">
                        <div className="card-body">
                            <div className="fw-bold">{table4?.find(t => t)?.location?.shortDescription}</div>
                        </div>
                    </div>
                    {table4 && table4?.map((item, index) => {
                        return (<div key={index}><ScoresLiveCard data={item} key={item?.eventUnit?.code} /></div>)
                    })}
                </div>}
            </div>
        </div >
    </>)
}
